import React, { useState, useEffect } from 'react';

const CustomSelect = ({ options = [], label, value, initialValue, onSelect, className }) => {
    const [selectedValue, setSelectedValue] = useState(initialValue || '');

    useEffect(() => {
        if (initialValue !== undefined) {
            setSelectedValue(initialValue);
        }
    }, [initialValue]);

    const handleChange = (e) => {
        const val = e.target.value;
        setSelectedValue(val);
        const selectedOption = options.find(opt => String(opt[value]) === String(val));
        if (onSelect) {
            onSelect(selectedOption);
        }
    };

    return (
        <select 
            className={className || "form-input-custom"} 
            value={selectedValue} 
            onChange={handleChange}
        >
            {!initialValue && <option value="" disabled>Seleccione...</option>}
            {options.map((opt, index) => (
                <option key={index} value={opt[value]}>
                    {opt[label]}
                </option>
            ))}
        </select>
    );
};

export default CustomSelect;
